module.exports = __webpack_public_path__ + "static/img/car2.9d3e596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car2.png
// module id = SK/A
// module chunks = 1